import React, { useEffect, useRef, useState } from 'react'
import { CToast, CToastBody, CToastHeader, CToaster } from '@coreui/react'
import { useDispatch, useSelector } from 'react-redux'

// import action
import { toast } from 'src/lib/toast'

const ToastCAlert = () => {
  const dispatch = useDispatch()

  // state
  const [display, addDisplay] = useState(0)
  const toaster = useRef()

  //redux-state
  const { type, message } = useSelector((state) => state.toast)

  const exampleToast = (
    <CToast show="true" position="static">
      <CToastHeader closeButton>
        <svg
          className="rounded me-2"
          width="20"
          height="20"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid slice"
          focusable="false"
          role="img"
        >
          <rect width="100%" height="100%" fill="#007aff"></rect>
        </svg>
        <strong className="me-auto">Aeroverse</strong>
      </CToastHeader>
      <CToastBody style={{ color: type === 'success' ? 'green' : type === 'error' ? 'red' : 'blue' }}>{message}</CToastBody>
    </CToast>
  )

  useEffect(() => {
    if (type && type !== undefined) {
      addDisplay(exampleToast)
      toast({}, dispatch)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, type])

  return <CToaster ref={toaster} push={display} placement="top-end" />
}

export default ToastCAlert
